export interface IEvent {
  category: string;
  action: string;
  label?: string;
  value?: number;
  namespace?: string;
}

export interface IKeyValue {
  [key: string]: any;
}

export interface IDimensions extends IKeyValue {}

export enum NamespaceType {
  CAPTURE_ALL,
  ISOLATED,
}

export interface INamespaceDefinition {
  namespaceType: NamespaceType;
  namespace: string | null | undefined;
}

export default abstract class AnalyticsProvider {
  protected namespaceType: NamespaceType;
  protected namespace: string | null | undefined;

  constructor(
    namespaceType: NamespaceType = NamespaceType.CAPTURE_ALL,
    namespace: string | null | undefined = null
  ) {
    this.namespaceType = namespaceType;
    this.namespace = namespace;

    if (namespaceType === NamespaceType.ISOLATED && !namespace) {
      throw new Error(
        'ISOLATED providers require a namespace to be defined. Please add a namespace string to your arguments at construction.'
      );
    }
  }

  protected shouldTrack(namespace: string | null | undefined) {
    return (
      this.namespaceType === NamespaceType.CAPTURE_ALL ||
      this.namespace === namespace
    );
  }

  abstract initialize(): boolean;
  abstract event(event: IEvent, trackerNames?: string[]): void;
  abstract setDimension(dimensions: IDimensions, trackerNames?: string[]): void;
  abstract option(key: string, value: any): void;
  abstract pageView(
    route: string,
    namespace?: string | null | undefined,
    trackerNames?: string[],
    title?: string
  ): void;
  error(_error: ErrorEvent) {}
}
